/**
 * 统一处理秒级 / 毫秒级时间戳
 * @param {number|string|Date} time
 * @returns {Date}
 */
const normalizeDate = (time) => {
	if (!time) return null
  
	// Date 类型直接返回
	if (time instanceof Date) return time
  
	const timestamp = Number(time)
  
	if (!Number.isNaN(timestamp)) {
	  // 秒级时间戳（10 位左右）
	  if (timestamp < 1e12) {
		return new Date(timestamp * 1000)
	  }
	  // 毫秒级时间戳
	  return new Date(timestamp)
	}
  
	// 字符串日期
	return new Date(time)
  }
  
  /**
   * 是否昨天
   */
  const isYesterday = (date) => {
	const today = new Date()
	today.setHours(0, 0, 0, 0)
  
	const yesterday = new Date(today)
	yesterday.setDate(today.getDate() - 1)
  
	return date >= yesterday && date < today
  }
  
  /**
   * 是否今年
   */
  const isThisYear = (date) => {
	return date.getFullYear() === new Date().getFullYear()
  }
  
  /**
   * 格式化日期
   */
  const pad = (n) => (n < 10 ? '0' + n : n)
  
  const formatDateTime = (date) => {
	if (!date) return ''
	return `${date.getFullYear()}/${pad(date.getMonth() + 1)}/${pad(date.getDate())} ` +
		   `${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`
  }
  
  /**
   * 时间显示文案
   * @param {number|string|Date} time
   * @param {boolean} simple
   */
  const toTimeText = (time, simple = false) => {
	const dateTime = normalizeDate(time)
	if (!dateTime) return ''
  
	const now = Date.now()
	const diff = now - dateTime.getTime()
  
	if (diff <= 60 * 1000) {
	  return '刚刚'
	}
  
	if (diff < 60 * 60 * 1000) {
	  return Math.floor(diff / 60000) + '分钟前'
	}
  
	if (diff < 24 * 60 * 60 * 1000 && !isYesterday(dateTime)) {
	  return formatDateTime(dateTime).substr(11, 5)
	}
  
	if (isYesterday(dateTime)) {
	  return '昨天 ' + formatDateTime(dateTime).substr(11, 5)
	}
  
	if (isThisYear(dateTime)) {
	  return formatDateTime(dateTime).substr(5, simple ? 5 : 14)
	}
  
	let text = formatDateTime(dateTime)
	if (simple) {
	  text = text.substr(2, 8)
	}
	return text
  }
  
  export {
	toTimeText,
	formatDateTime,
	isYesterday,
	isThisYear
  }
  